'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _Carousel = require('../../components/Carousel/Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ItemCardCarousel = require('./ItemCardCarousel.scss');

var _ItemCardCarousel2 = _interopRequireDefault(_ItemCardCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemCardCarousel = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(ItemCardCarousel, _Component);

    function ItemCardCarousel() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, ItemCardCarousel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ItemCardCarousel.__proto__ || (0, _getPrototypeOf2.default)(ItemCardCarousel)).call.apply(_ref, [this].concat(args))), _this), _this.mapCarouselItems = function (item, itemIndex) {
            if (item) {
                return (0, _jsx3.default)('div', {}, itemIndex, (0, _jsx3.default)(_components.ItemCard, {
                    cardViewModel: item,
                    className: _ItemCardCarousel2.default.item,
                    last: false
                }));
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(ItemCardCarousel, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'headerMessage', 'index', 'items']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                afterChange = _props.afterChange,
                className = _props.className,
                headerMessage = _props.headerMessage,
                index = _props.index,
                items = _props.items;


            var carouselItems = items.map(this.mapCarouselItems);

            // don't draw the carousel if we've got nothing to draw
            if (carouselItems.length < 2) {
                return null;
            }

            var classes = (0, _classnames2.default)(_ItemCardCarousel2.default.container, className);

            return (0, _jsx3.default)('div', {
                className: classes
            }, void 0, (0, _jsx3.default)('div', {
                className: _ItemCardCarousel2.default.header
            }, void 0, (0, _jsx3.default)('h2', {}, void 0, headerMessage)), (0, _jsx3.default)(_Carousel2.default, {
                afterChange: afterChange,
                index: index
            }, void 0, carouselItems));
        }
    }]);
    return ItemCardCarousel;
}(_react.Component), _class.defaultProps = {
    afterChange: _noop2.default
}, _temp2);
exports.default = ItemCardCarousel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/ItemCardCarousel.js
// module id = ZXiL
// module chunks = 46